import Alert from './alert';
import $ from 'jquery';

var RemoveWatch = {
  btns    : null,
  request : null,

  bind: function() {
    this.btns = $('.delete-watch');
    this.count = $('#results-count');

    this.btns
      .off('click')
      .on('click', this.removeWatch);
  },

  removeWatch: function(e) {
    e.preventDefault();

    var self  = $(this);
    var id    = self.data('id');
    var row   = self.closest('tr');
    var data  = {
      'id': id,
      'HTTP_X_HTTP_METHOD_OVERRIDE': 'DELETE'
    }

    if(RemoveWatch.request !== null) {
      RemoveWatch.request.abort();
    }

    RemoveWatch.request = $.ajax({
      'method'    : 'POST',
      'url'       : self.attr('href'),
      'dataType'  : 'json',
      'data'      : data
    })
    .done(function(response) {
      Alert.show({ level: 'success', message: response.message });
      row.remove();
      RemoveWatch.reduceCount();
    })
    .fail(function(response) {
      Alert.show({ level: 'danger', message: response.message });
    });
  },

  reduceCount: function() {
    var oldCount = parseInt(this.count.html());

    this.count.html(oldCount - 1);
  }
};

export default RemoveWatch;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/remove_watch.js